import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	background-color: ${colors.white};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	padding: 2%;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 14px;
	color: ${colors.black};
	flex: 1;
`;

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

export const NoData = styled.div`
	color: ${colors.grey7};
	font-size: 16px;
	letter-spacing: 0.3px;
	padding: 16px 0 16px 0px;
`;

export const TooltipContainer = styled.ul`
	display: flex;
	flex-direction: column;
	padding: 8px 12px;
	margin: 0;
	z-index: 2;
	background-color: ${colors.white};
`;

export const TooltipItemTitle = styled.strong`
	font-size: 13px;
	font-weight: bold;
	margin: 0 auto 8px;
`;

export const TooltipItem = styled.li`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 13px;
`;

export const TooltipItemName = styled.span`
	text-transform: capitalize;
`;

export const TooltipItemValue = styled.strong`
	margin-left: 12px;
`;

export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: center;
	> div {
		> div {
			border-radius: 0;
		}
	}
	.actions {
		height: 32px;
		font-size: 14px;
	}
`;

export const Label = styled.div`
	font-weight: 400;
	font-size: 13px;
	line-height: 16px;
	color: ${colors.grey5};
	padding-left: 16px;
	padding-right: 4px;

	&:first-child {
		padding-left: 0;
	}
`;

export const ActionsWrapper = styled.div`
	display: flex;
	gap: 6px;
`;
